module.exports = __webpack_public_path__ + "img/icon-user-plus-active.85e58435.svg";